import { apiClient } from './apiClient';

export interface NotificationMetadata {
  [key: string]: string;
}

export interface Notification {
  id: string;
  entity: string;
  entity_id: string;
  entity_action: string;
  entity_action_type: 'failure' | 'success' | 'info';
  title: string;
  message: string;
  metadata: NotificationMetadata;
  audiences: string[];
  created_at: string;
  updated_at: string;
}

export interface NotificationsResponse {
  success: boolean;
  count: number;
  data: Notification[];
  timestamp?: string;
}

export const notificationService = {
  async getNotifications(): Promise<Notification[]> {
    const response = await apiClient.get<NotificationsResponse>('/notifications');
    if (response.success && Array.isArray(response.data)) {
      return response.data;
    }
    return [];
  },

  markAsRead(id: string): void {
    // Fire-and-forget: do not await
    apiClient.post(`/notifications/mark-as-read/${id}`, {}).catch(() => {
      // Silently ignore errors; the banner is already dismissed
    });
  },
};
